export const validationInput = [
  {
    key: "name",
    type: "text",
  },
  {
    key: "first_name",
    type: "text",
  },
  {
    key: "last_name",
    type: "text",
  },
  {
    key: "gender",
    type: "text",
  },
  {
    key: "dob",
    type: "text",
  },
  // {
  //   key: "uniqueName",
  //   type: "domain",
  // },
  {
    key: "email",
    type: "email",
  },
  {
    key: "password",
    type: "text",
  },
];
